import { call, put, takeLatest, all } from "redux-saga/effects";
import { toastr } from "react-redux-toastr";
import { push } from "react-router-redux";

import Session from "../../utility/session";

import {
  SUBSCRIBE_PLAN,
  SUBSCRIBE_PLAN_SUCCEDED,
  SUBSCRIBE_PLAN_FAILED,
  RATE_CARD,
  RATE_CARD_SUCCEDED,
  RATE_CARD_FAILED,
  PLAN_SIZE_CHANGE,
  CHECK_OUT_PAYMENT,
  CHECK_OUT_PAYMENT_SUCCEDED,
  CHECK_OUT_PAYMENT_FAILED,
  SETTINGS_PAYMENT_HISTORY,
  SETTINGS_PAYMENT_HISTORY_SUCCEEDED,
  SETTINGS_PAYMENT_HISTORY_FAILED,
  LOAD_PROFILE_DETAILS,
  LOAD_PROFILE_DETAILS_SUCCEEDED,
  LOAD_UPLOADED_DETAILS_FAILED,
  UPDATE_PROFILE_DETAILS,
  UPDATE_PROFILE_DETAILS_SUCCEEDED,
  UPDATE_PROFILE_DETAILS_FAILED,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCEEDED,
  UPDATE_PASSWORD_FAILED,
  RECURRING_PAYMENT,
  RECURRING_PAYMENT_FAILED,
  RECURRING_PAYMENT_SUCCEEDED,
  USER_PAST_UPLOADS, 
  USER_PAST_UPLOADS_SUCCEDED, 
  USER_PAST_UPLOADS_FAILED,
} from "../../common/constants";

import * as api from "../../services/settings";
import { showAlert } from "../../utility/alertHelper";
// import history from "../../utility/history";
// function* loginSaga() {

function* getUploadHistory(action) {
  try {
    const uploadHistory = yield call(api.getPastUploads, action.email, action.page, action.limit);
    if (uploadHistory) {
      yield put({
        type: USER_PAST_UPLOADS_SUCCEDED,
        uploadHistory,
      });
    } else {
      yield put({
        type: USER_PAST_UPLOADS_FAILED,
        args: {
          message: uploadHistory.msg,
        },
      });
    }
  } catch (error) {
    yield put({
      type: USER_PAST_UPLOADS_FAILED,
      args: {
        message: error.message,
      },
    });
  }
}  
//Worker saga
function* getPaymentHistory(action) {
  try {
    const paymentHistory = yield call(api.getPaymentHistory, action.mmCustomerID);

    if (paymentHistory) {
      yield put({
        type: SETTINGS_PAYMENT_HISTORY_SUCCEEDED,
        paymentHistory: paymentHistory
      });
    } else {
      yield put({
        type: SETTINGS_PAYMENT_HISTORY_FAILED,
        args: {
          message: paymentHistory.msg
        }
      });
    }
  } catch (error) {
    yield put({
      type: SETTINGS_PAYMENT_HISTORY_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

//Worker saga
function* loadProfileDetails(action) {
  try {
    const profileInfo = yield call(api.loadProfile, action.username);

    if (profileInfo.success) {
      yield put({
        type: LOAD_PROFILE_DETAILS_SUCCEEDED,
        profileInfo: profileInfo.result
      });
    } else {
      showAlert(profileInfo.msg);
      yield put({
        type: LOAD_UPLOADED_DETAILS_FAILED,
        args: {
          message: profileInfo.msg
        }
      });
    }
  } catch (error) {
    yield put({
      type: LOAD_UPLOADED_DETAILS_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

//Worker saga
function* updateProfileDetails(action) {
  try {
    const updateProfileInfo = yield call(api.updateProfile, action.profileInfo);

    if (updateProfileInfo.success) {
      if (action.profileInfo.name != Session.getItem(Session.CURRENT_NAME))
        Session.setItem(Session.CURRENT_NAME, action.profileInfo.name);
      showAlert(updateProfileInfo.msg);
      yield put({
        type: UPDATE_PROFILE_DETAILS_SUCCEEDED,
        profileInfo: action.profileInfo
      });
    } else {
      showAlert(updateProfileInfo.msg);
      yield put({
        type: UPDATE_PROFILE_DETAILS_FAILED,
        args: {
          message: updateProfileInfo.msg
        }
      });
    }
  } catch (error) {
    showAlert({
      msg_code: "",
      msg_type: "error",
      msg_text: "profile details updation failed " + error.message
    });
    yield put({
      type: UPDATE_PROFILE_DETAILS_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

//Worker saga
function* updatePasswordDetails(action) {
  try {
    const updatePasswordInfo = yield call(api.updatePassword, action.passwordInfo);

    if (updatePasswordInfo.success) {
      showAlert(updatePasswordInfo.msg);
      yield put({
        type: UPDATE_PASSWORD_SUCCEEDED,
        passwordInfo: action.passwordInfo
      });
    } else {
      showAlert(updatePasswordInfo.msg);

      yield put({
        type: UPDATE_PASSWORD_FAILED,
        args: {
          message: updatePasswordInfo.msg
        }
      });
    }
  } catch (error) {
    showAlert({
      msg_code: "",
      msg_type: "error",
      msg_text: "Password update failed " + error.message
    });
  }
}

//Worker saga
function* getRecurringPayment(action) {
  try {
    debugger;
    const recurringpayment = yield call(api.getRecurringPayment);

    if (recurringpayment) {
      yield put({
        type: RECURRING_PAYMENT_SUCCEEDED,
        recurringpayment: recurringpayment
      });
    } else {
      yield put({
        type: RECURRING_PAYMENT_FAILED,
        args: {
          message: recurringpayment.msg
        }
      });
    }
  } catch (error) {
    yield put({
      type: RECURRING_PAYMENT_FAILED,
      args: {
        message: error.message
      }
    });
  }
}
// listener Saga
function* ongetUploadHistory(){
  yield takeLatest(USER_PAST_UPLOADS, getUploadHistory)
}

function* ongetPaymentHistory() {
  yield takeLatest(SETTINGS_PAYMENT_HISTORY, getPaymentHistory);
}
function* ongetRecurringPayment() {
  yield takeLatest(RECURRING_PAYMENT, getRecurringPayment);
}
// listener Saga
function* loadProfile() {
  yield takeLatest(LOAD_PROFILE_DETAILS, loadProfileDetails);
}

// listener Saga
function* updateProfile() {
  yield takeLatest(UPDATE_PROFILE_DETAILS, updateProfileDetails);
}

// listener Saga
function* updatePassword() {
  yield takeLatest(UPDATE_PASSWORD, updatePasswordDetails);
}

export default function* settingsSaga() {
  yield [ongetPaymentHistory(), ongetRecurringPayment(), loadProfile(), updateProfile(), updatePassword(), ongetUploadHistory()];
}



// WEBPACK FOOTER //
// ./src/Containers/Settings/sagas.js